import maplibregl from 'maplibre-gl';

export function setupMarkers(map, config) {
  if (!config.showMarkers || !config.chapters || !config.chapters.length) {
    return null;
  }

  const initialChapter = config.chapters[0];
  const { center } = initialChapter.location;

  const marker = new maplibregl.Marker({ color: config.markerColor || '#FF0000' });
  marker.setLngLat(center).addTo(map);

  return marker;
}
